<template>
    <div class="borrowDetailsBox">
        <Box title="资产详情">
            <div class="equipment box">
                <p class="title">资产详细信息</p>
                <div class="equipment-details">
                    <img src="@/assets/img/Icon_1.png" />
                    <div>
                        <div>
                            <p>资产名称:</p>
                            <p>资产编号:</p>
                            <p>资产单位:</p>
                            <p>资产原值:</p>
                            <p>资产折旧:</p>
                            <p>资产净值:</p>
                            <P>资产分类:</P>
                            <P>存放地点:</P>

                        </div>
                        <div>
                            <p class="ellipsis">{{ parentData.AssetName }}</p>
                            <p class="ellipsis">{{ parentData.AssetNo }}</p>
                            <p class="ellipsis">{{ parentData.AssetUnit }}</p>
                            <p class="ellipsis">{{ parentData.Original }}</p>
                            <p class="ellipsis">{{ parentData.Depreciation }}</p>
                            <p class="ellipsis">{{ parentData.AssetTypeName }}</p>
                            <p class="ellipsis">{{ parentData.Location }}</p>

                        </div>
                    </div>
                </div>
            </div>
            <div class="borrow box">
                <p class="title">盘点信息</p>
                <Field title="使用科室" name="departmentList" :text="parentData.DepartmentName"
                @manuconfirm="SaveInfo[0].PDKS = arguments[0].a,
                    SaveInfo[0].DepartmentName = arguments[0].b" type="manufacturer" placeholder="请选择使用科室" />

                <Field title="资产规格" type="input" :text="parentData.AssetSize" placeholder="请输入资产规格"
                    @onMessage='e => SaveInfo[0].AssetSize = e' />

                <Field title='设备状态' :action='true' type='manufacturer' name='assetstates' placeholder='请选择设备状态'
                    :text='parentData.AssetStateName'
                    @manuconfirm='SaveInfo[0].State = arguments[0].a, parentData.AssetStateName=arguments[0].b' />

                <Field title="存放地点" type="input" :text="parentData.Location" placeholder="请输入存放地点"
                    @onMessage='e => SaveInfo[0].Location = e' />

            </div>
            <div class="footer">
                <div class="button" @click="upload">保存</div>
            </div>
        </Box>
    </div>
</template>

<script>
    import Box from "@/components/commonBox/commonBox";
    import ImgModule from "../../components/imgModule/imgModule";
    import Field from "@/components/field/field";
    import {
        Toast,
        ImagePreview
    } from "vant";

    export default {
        name: "InventoryEquipment",
        data() {
            return {
                parentData: this.$route.params.item,
                SaveInfo: [{
                    State: this.$route.params.item.AssetState,
                    DepartmentId: this.$route.params.item.DepartmentId,
                    Location: this.$route.params.item.Location,
                    PDKS: this.$route.params.item.PDKS,
                    DepartmentName: '',
                    InventoryNo: this.$route.params.item.InventoryNo,
                    EquId: this.$route.params.item.AssetNo,
                    AssetSize: this.$route.params.item.AssetSize
                }]
            };
        },
        components: {
            Box,
            Field,
            ImgModule,
        },
        methods: {
            upload() { //保存
                debugger
                this.$post("api/Inventory/UpdateInventoryItem", {
                    InventoryNo: this.parentData.InventoryNo,
                    StoreId: this.$UserInfo.StoreCode,
                    ItemList: JSON.stringify(this.SaveInfo),
                }).then((result) => {
                    if (result.Status) {
                        this.$Toast({
                            message: result.Msg,
                            duration: 1500,
                            onClose: () => {
                                this.$router.back()
                            }
                        });
                    } else this.$Toast(result.Msg);
                });
            },
        }
    };
</script>

<style scoped lang="scss">
    .box {
        background: $BACKGROUND-COLOR;
        border-radius: 12px;
        padding: 34px 40px 0;
        box-sizing: border-box;
        margin-bottom: 20px;
    }

    .title {
        color: $TEXT-DARK-COLOR;
        font-size: 34px;
        font-weight: bold;
    }

    .equipment {
        height: 580px;

        img {
            width: 150px;
            height: 150px;
        }

        .equipment-details {
            display: flex;
            margin-top: 24px;

            &>div {
                margin-left: 34px;
                display: flex;

                div {
                    &:first-child {
                        color: #999;
                        line-height: 55px;
                    }

                    &:last-child {
                        color: #333;
                        line-height: 55px;

                        p {
                            width: 280px;
                            font-size: 29px;
                            color: #333;
                        }
                    }
                }
            }
        }

        &>div:last-child {
            display: flex;
            border-top: 2px solid #f3f3f3;
            margin-top: 20px;

            div {
                flex: 1;
                text-align: left;
                height: 66px;
                line-height: 66px;
                font-size: 29px;
                color: #999;

                &:first-child {
                    border-right: 2px solid #f3f3f3;
                }
            }
        }
    }

    .accessories {
        .title {
            margin-bottom: 10px;
        }

        .check-box {
            display: flex;
            height: 112px;
            border-bottom: 2px solid #f3f3f3;

            &:last-child {
                border: none;
            }

            .van-checkbox {
                flex: 1;
            }
        }
    }

    .borrow {
        .title {
            margin-bottom: 10px;
        }
    }

    .explain {
        input {
            width: 100%;
            text-align: left;
            margin: 20px 0 48px;
        }
    }

    input {
        width: 150px;
        font-size: 29px;
        text-align: center;
        color: #858585;

        &::-webkit-input-placeholder {
            color: #858585;
        }
    }

    .footer {
        position: fixed;
        bottom: 0;
        width: 100%;
        height: 114px;
        background: $BACKGROUND-COLOR;
        box-shadow: 0px 6px 12px rgba(0, 0, 0, 0.16);
        padding-top: 24px;

        .button {
            width: 690px;
            height: 96px;
            background: $THEME-COLOR;
            border-radius: 8px;
            color: $TEXT-LIGHT-COLOR;
            font-size: 30px;
            text-align: center;
            line-height: 96px;
            margin: auto;
        }
    }
</style>



// WEBPACK FOOTER //
// src/page/Inventory/InventoryEquipment.vue